// extracted by mini-css-extract-plugin
export var buttonContent = "_2r-0";
export var centered = "_2r-1";
export var centeredFlex = "_2r-2";
export var errorText = "_2r-3";
export var icon = "_2r-4";
export var iconButtonContent = "_2r-5";
export var monospace = "_2r-6";
export var padded = "_2r-7";